import { render, staticRenderFns } from "./BaseRoundButton.vue?vue&type=template&id=6b27214e"
import script from "./BaseRoundButton.vue?vue&type=script&lang=js"
export * from "./BaseRoundButton.vue?vue&type=script&lang=js"
import style0 from "./BaseRoundButton.vue?vue&type=style&index=0&id=6b27214e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports